import { configureStore } from "@reduxjs/toolkit";
import { authAdminReducer } from "./slice/authAdminSlice";
import { productReducer } from "./slice/productSlice";
import { userReducer } from "./slice/userSlice";
import { categoryReducer } from "./slice/categorySlice";
import { subcategoryReducer } from "./slice/subcategorySlice";
import { orderReducer } from "./slice/orderSlice";
import { authReducer } from "./slice/authSlice";
import { cartReducer } from "./slice/cartSlice";

const store = configureStore({
  reducer: {
    admin: authAdminReducer,
    product: productReducer,
    user: userReducer,
    category: categoryReducer,
    subcategory: subcategoryReducer,
    order: orderReducer,
    auth: authReducer,
    cart: cartReducer,
  },
});

export default store;
